export enum IFrameEvents {
  CHANGE_CITY = "changeCity",
  ENTER_BUSINESS = "enterBusiness",
  ACCOUNT_CHANGE = "accountChange",
  PAGE_READY = "pageReady",
  AUTH_SIGNED = "authSigned",
}
